import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { errorService, errorPayment } from '../../../../utils/texts';
import { Button } from '../../../../components/atoms';
import { Layout } from '../../../../components/organisms';
import Warning from '../../../../assets/error/full-ic-error.svg';
import Card from '../../../../assets/error/full-ic-error-card.svg';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';

const ErrorServicePage = ({ payment }) => {
  const navigate = useNavigate();
  const pageTexts = payment ? errorPayment : errorService;
  const {
    title,
    subtitle,
    btnText,
  } = pageTexts;

  return (
    <Layout>
      <RegisterAuditory
        authoring={{
          paso: 7,
          pasoDescripcion: 'PASO_ERROR_SERVICIO',
        }}
      />
      <div className="error-service-page">
        <div className="container">
          <div className="page-error">
            <img src={payment ? Card : Warning} alt="icono de error" />

            <div className="page-error-title">
              {title}
            </div>

            <div className="page-error-subtitle">
              {subtitle}
            </div>

            <div className="page-error-button">
              <Button
                label={btnText}
                onClick={() => navigate('/comprar/seguro-salud-flexible')}
                type="primary"
              />
            </div>

          </div>
        </div>
      </div>
    </Layout>
  );
};

ErrorServicePage.propTypes = {
  payment: PropTypes.bool,
};

ErrorServicePage.defaultProps = {
  payment: false,
};

export default ErrorServicePage;
